export default "__VITE_ASSET__$sQTSoLh__"